import React from 'react'
import PropTypes from 'prop-types'
import { Card, LazyImage, Heading, HyperButton, Text } from '@offerzen/pinata-shame'

import styles from './styles'

const ErrorCard = ({ image, altText, heading, subheading, cta }) => {
  return (
    <Card className={styles.card}>
      <LazyImage loader={() => import(`../../../assets/${image}`)} alt={altText || ''} width={210} />
      <Heading>
        <strong>{heading}</strong>
      </Heading>

      <If condition={subheading}>
        <Text>
          <p>{subheading}</p>
        </Text>
      </If>

      <HyperButton className={styles.button} label={cta.label} size="medium" href={cta.href} external />
    </Card>
  )
}

ErrorCard.propTypes = {
  image: PropTypes.string.isRequired,
  altText: PropTypes.string,
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  cta: PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
  }).isRequired,
}

export default ErrorCard
